module.exports = __webpack_public_path__ + "img/post_4.222e1bf7.png";